import { api } from "@/lib/api";

export interface EmailSettings {
  provider: "mock" | "smtp";
  from_address: string;
  from_name: string;
  smtp_host: string;
  smtp_port: number;
  smtp_username: string;
  smtp_use_tls: boolean;
  smtp_password_set: boolean;
}

export interface EmailSettingsUpdate {
  provider?: "mock" | "smtp";
  from_address?: string;
  from_name?: string;
  smtp_host?: string;
  smtp_port?: number;
  smtp_username?: string;
  smtp_password?: string; // blank keeps the stored one
  smtp_use_tls?: boolean;
}

export function getEmailSettings(): Promise<EmailSettings> {
  return api.get<EmailSettings>("/settings/email");
}

export function updateEmailSettings(body: EmailSettingsUpdate): Promise<EmailSettings> {
  return api.put<EmailSettings>("/settings/email", body);
}

export function sendTestEmail(to_address: string): Promise<{ message: string }> {
  return api.post<{ message: string }>("/settings/email/test", { to_address });
}

// --- company profile (letterhead) ---

export interface CompanySettings {
  name: string;
  address: string;
  phone: string;
  email: string;
  website: string;
  gstin: string;
  has_logo: boolean;
  logo_mime: string;
}

export interface CompanySettingsUpdate {
  name?: string;
  address?: string;
  phone?: string;
  email?: string;
  website?: string;
  gstin?: string;
}

/** Authenticated logo path — pass to fetchBlobUrl for an <img> preview. */
export const COMPANY_LOGO_PATH = "/settings/company/logo";

export function getCompanySettings(): Promise<CompanySettings> {
  return api.get<CompanySettings>("/settings/company");
}

export function updateCompanySettings(body: CompanySettingsUpdate): Promise<CompanySettings> {
  return api.put<CompanySettings>("/settings/company", body);
}

export function uploadCompanyLogo(file: File): Promise<CompanySettings> {
  const form = new FormData();
  form.append("file", file);
  return api.upload<CompanySettings>("/settings/company/logo", form);
}

export function deleteCompanyLogo(): Promise<CompanySettings> {
  return api.delete<CompanySettings>("/settings/company/logo");
}
